export const ShosseynayaData = [
    {
        title: "дом №4",
        year: '1974',
        floor: "2",
        apartment: "8",
        quantityLC: "8",
        livingArea: "384,74",
        notLivinigArea: "нет",
        commonProperty: "30",
        type: "многоэтажный жилой дом",
        level: "ХВС, отопление, газоснабжение, электроснабжение",
        technicalSupport: "общедомовой прибор учета электроэнергии",
        contractURL: 'shosseynaya/mitropole_shosseynaya_4_dogovor.pdf',
        protocolURL: 'protocol_4_2017-02-16.pdf',
    }
]